import styled from 'styled-components'

export const LayoutContainer = styled.div`
    position: relative;
    min-height: 100vh;
    width: 100%;
`

export const FloatingUIContainer = styled.div`
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 50;
    display: flex;
    align-items: center;
    gap: 16px;

    @media (max-width: 768px) {
        top: 16px;
        right: 16px;
        gap: 8px;
    }
`

export const ContentContainer = styled.main`
    width: 100%;
    min-height: 100vh;
    /* Maintains existing page styling */
`
